import './topNavBarOption.css'
import { Link } from "react-router-dom";
const TopNavBarOption = ({text, to}) => {
    return ( <Link to={to} className="topNavBarOption">{text}</Link> );
}
 
export default TopNavBarOption;